import React, { useEffect, useState } from "react";
import moment from "moment";
import { toBool } from "../../JS/utility";
import { formatTime } from "../spaBookingV2/spaBooking2a";
import { setShowCustomPopup } from "../../../action/action";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import UpdateBookingPage from "./UpdateBookingPage";
import { scrollToTop } from "../../../JS/scrollToTop";

function BookingOverviewPage(props){

    const {bookingOverviewDetails, handleUpdateBooking, handleCancelBooking, t } = props;
    const [updateBookingFlowEnabled, setUpdateBookingFlowEnabled] = useState(false)

    const cancelBookingOnClick=()=>{
        props.setShowCustomPopup(true, {
            htmlTagId: "cancel-way-activity",
            title: t("way_activity.booking_overview_page.cancel_popup.title"),
            heading: t("way_activity.booking_overview_page.cancel_popup.heading"),
            primaryButtonText: t("way_activity.booking_overview_page.cancel_popup.primary_button"),
            closeOnClick:()=>{props.setShowCustomPopup(false,{})},
            primaryOnClick: () => { handleCancelBooking(bookingOverviewDetails); props.setShowCustomPopup(false,{}) },
        })
    }

    useEffect(()=>{
        scrollToTop()
    },[])

    return <section id="activitiespage-edit-booking-overview" className="widgets activity-listing container-bg">

        {
            updateBookingFlowEnabled ?
                <UpdateBookingPage handleUpdateBooking={handleUpdateBooking} setLoaderDetails={props.setLoaderDetails} bookingOverviewDetails={bookingOverviewDetails} />
            :
            <section className="activity-summary-page">

            <div className="summary-container">
            <div className="">
                <div className="widget-header-title">{t("way_activity.booking_overview_page.header_title")}</div>
                <div className="widget-header-subtitle">{t("way_activity.booking_overview_page.header_subtitle")}</div>
            </div>
            <div>
                <div class="field-title">{t("way_activity.booking_overview_page.experience_name_label")}</div>
                <div class="answer">{bookingOverviewDetails.experience.title}</div>
    
    
                { bookingOverviewDetails.event.startDateTime && <> <div class="field-title">{t("way_activity.booking_overview_page.date_label")}</div>
                <div class="answer">{moment(bookingOverviewDetails.event.startDateTime.split("T")[0]).format(props.dateFormat.toUpperCase())}</div> </>
                }
    
               { bookingOverviewDetails.event.startDateTime  && <> <div class="field-title">{t("way_activity.booking_overview_page.time_label")}</div>
                <div class="answer">{formatTime(bookingOverviewDetails.event.startDateTime .split("T")[1], toBool(props.timeFormat))}</div> </>
                }
                
                {
                    bookingOverviewDetails.participants && bookingOverviewDetails.participants.length > 0 &&  <>
                <div class="field-title">{t("way_activity.booking_overview_page.price_tiers_label")}</div>
                <div className="answer-multiple">
                    <ol>
                    {
                        bookingOverviewDetails.participants.map(participant =>
                            <>
                             <li>
                                <div class="answer-1">{t("way_activity.booking_overview_page.participant_entry", { priceTierName: participant.priceTierName, firstName: participant.firstName, lastName: participant.lastName })}</div>
                            </li>
                            </>
                        )
                    }
                    </ol>
                     
                </div>
                </>
                }

                {
                    bookingOverviewDetails.addOns && bookingOverviewDetails.addOns.length > 0 &&  <>
                <div class="field-title">{t("way_activity.booking_overview_page.add_ons_label")}</div>
                <div className="answer-multiple">
                    <ol>
                    {
                        bookingOverviewDetails.addOns.map(addOn =>
                            <>
                             <li>
                                <div class="answer-1">{`${addOn.label}`}</div>
                            </li>
                            </>
                        )
                    }
                    </ol>
                     
                </div>
                </>
                }

    
                <div class="field-title">{t("way_activity.booking_overview_page.amount_label")}</div>
                <div class="answer">{bookingOverviewDetails.currency + " " + bookingOverviewDetails.amount}</div>
    
    
            </div>
    
            <div class="row">
                            <div class="form-controls">
                                <button  
                                    className="update"
                                    onClick={()=>{setUpdateBookingFlowEnabled(true)}} >
                                    {t("way_activity.booking_overview_page.update_button")}
                                </button> 
                                <button  
                                    className="cancel"
                                    onClick={()=>{cancelBookingOnClick()}} >
                                    {t("way_activity.booking_overview_page.cancel_button")}
                                </button>
                            </div>
            </div>
    
            </div>
    
            </section>


        }
       

     </section>
}

const mapStateToProps = (state) => {
    return {
      installedAppVersion: state.store.installedAppVersion,
      installedAppBuildNo: state.store.installedAppBuildNo,
      currentHomePage: state.store2.currentHomePage,
      currentWidgetObj: state.store.sideNavBar.currentWidget,
      guestDetail: state.store.home.guestDetails,
      guestIsLoggedIn: state.store2.guestIsLoggedIn,
      currentWidgets: state.store.sideNavBar.currentWidget,
      dateFormat: state.store.home.clientConfig.extraConfigParam
        ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
        : "",
      // timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
      serverTimeDate: state.store.home.serverTimeDate.date,
      serverDate: state.store.home.serverTimeDate,
  
  
    };
  };
  
  export default connect(mapStateToProps, {setShowCustomPopup})(
    withTranslation("translations")(BookingOverviewPage)
  );